function generateIdFromName(name) {
    return name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
}

const telasParaCortina = [
    
    {
        nombre: 'Madeiras BO',
        colores: ['Abeto','Haya','Teca','Arce'],
        tipo: 'Blackout',
        anchoRollo: '2.80 M',
        composicion: '100% Poliéster',
        pesoTela: '360 g/m²',
        categoria:'Telas para cortina',
        maximo: '3.2',
        images: [
            require ('../../assets/img/productos/telasParaCortina/madeirasBO/1.jpg'), 
            require ('../../assets/img/productos/telasParaCortina/madeirasBO/1.jpg'), 
            require ('../../assets/img/productos/telasParaCortina/madeirasBO/2.jpg'), 
            require ('../../assets/img/productos/telasParaCortina/madeirasBO/3.jpg'), 
            require ('../../assets/img/productos/telasParaCortina/madeirasBO/4.jpg')
        ]
    },
    {
        nombre: 'Terra',
        colores: ['Crema', 'Gris','Lino'],
        tipo: 'Tergal',
        anchoRollo: '3.00 M',
        composicion: '100% Poliéster',
        pesoTela: '130 g/m²',
        categoria: 'Telas para cortina',
        images: [
            require ('../../assets/img/productos/telasParaCortina/terra/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/terra/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/terra/2.jpg'),
            require ('../../assets/img/productos/telasParaCortina/terra/3.jpg')
        ]
    },
    {
        nombre: 'Voile',
        colores: ['White', 'Champagne', 'Nude', 'Grey'],
        tipo: 'Tergal',
        anchoRollo: '3.00 M',
        composicion: '100% Poliéster',
        pesoTela: '48 g/m²',
        categoria: 'Telas para cortina',
        images: [
            require ('../../assets/img/productos/telasParaCortina/voile/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/voile/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/voile/2.jpg'),
            require ('../../assets/img/productos/telasParaCortina/voile/3.jpg'),
            require ('../../assets/img/productos/telasParaCortina/voile/4.jpg')
        ]
    },
    {
        nombre: 'Chiffon',
        colores: ['White','Nude', 'Grey', 'Mink'],
        tipo: 'Frescura',
        anchoRollo: '3.00 M',
        composicion: '100% Poliéster',
        pesoTela: '80 g/m²',
        categoria: 'Telas para cortina',
        images: [
            require ('../../assets/img/productos/telasParaCortina/chiffon/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/chiffon/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/chiffon/2.jpg'),
            require ('../../assets/img/productos/telasParaCortina/chiffon/3.jpg'),
            require ('../../assets/img/productos/telasParaCortina/chiffon/4.jpg')
        ]
    },
    {
        nombre: 'Gauze',
        colores: ['White','Champagne', 'Natural'],
        tipo: 'Frescura',
        anchoRollo: '3.00 M',
        composicion: '100% Poliéster',
        pesoTela: '90 g/m²',
        categoria: 'Telas para cortina',
        images: [
            require ('../../assets/img/productos/telasParaCortina/gauze/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/gauze/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/gauze/2.jpg'),
            require ('../../assets/img/productos/telasParaCortina/gauze/3.jpg')
        ]
    },
    {
        nombre: 'Liné',
        colores: ['Snow', 'Cream', 'Ash', 'Cement'],
        tipo: 'Tergal',
        anchoRollo: '3.00 M',
        composicion: '100% Poliéster',
        pesoTela: '115 g/m²',
        categoria: 'Telas para cortina',
        images: [
            require ('../../assets/img/productos/telasParaCortina/line/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/line/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/line/2.jpg'),
            require ('../../assets/img/productos/telasParaCortina/line/3.jpg'),
            require ('../../assets/img/productos/telasParaCortina/line/4.jpg')
        ]
    },
    {
        nombre: 'Lusso',
        colores: ['Lino', 'White', 'Champagne', 'Natural'],
        tipo: 'Frescura',
        anchoRollo: '3.00 M',
        composicion: '100% Poliéster',
        pesoTela: '80 g/m²',
        categoria: 'Telas para cortina',
        images: [
            require ('../../assets/img/productos/telasParaCortina/lusso/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/lusso/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/lusso/2.jpg'),
            require ('../../assets/img/productos/telasParaCortina/lusso/3.jpg'),
            require ('../../assets/img/productos/telasParaCortina/lusso/4.jpg')
        ]
    },
    {
        nombre: 'Nightfall',
        colores: ['White', 'Beige', 'Sand', 'Stone', 'Grey', 'Black', 'Oxford'],
        tipo: 'Blackout',
        anchoRollo: '2.80 M',
        composicion: '100% Poliéster',
        pesoTela: '230 g/m²',
        categoria: 'Telas para cortina',
        images: [
            require ('../../assets/img/productos/telasParaCortina/nightfall/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/nightfall/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/nightfall/2.jpg'),
            require ('../../assets/img/productos/telasParaCortina/nightfall/3.jpg'),
            require ('../../assets/img/productos/telasParaCortina/nightfall/4.jpg'),
            require ('../../assets/img/productos/telasParaCortina/nightfall/5.jpg'),
            require ('../../assets/img/productos/telasParaCortina/nightfall/6.jpg'),
            require ('../../assets/img/productos/telasParaCortina/nightfall/7.jpg')
        ]
    },
    {
        nombre: 'Tulum BO',
        colores: ['Vanila', 'Natural', 'Silver', 'Grey'],
        tipo: 'Blackout',
        anchoRollo: '2.80 M',
        composicion: '95% Poliéster 5% Lino',
        pesoTela: '400 g/m²',
        categoria: 'Telas para cortina',
        images: [
            require ('../../assets/img/productos/telasParaCortina/tulumBO/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/tulumBO/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/tulumBO/2.jpg'),
            require ('../../assets/img/productos/telasParaCortina/tulumBO/3.jpg'),
            require ('../../assets/img/productos/telasParaCortina/tulumBO/4.jpg')
        ]
    },
    {
        nombre: 'Drift BO',
        colores: ['Sochi', 'Monaco', 'Fuji', 'Shangai', 'Monza'],
        tipo: 'Blackout',
        anchoRollo: '2.80 M',
        composicion: '100% Poliéster',
        pesoTela: '440 g/m²',
        categoria: 'Telas para cortina',
        images: [
            require ('../../assets/img/productos/telasParaCortina/driftBO/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/driftBO/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/driftBO/2.jpg'),
            require ('../../assets/img/productos/telasParaCortina/driftBO/3.jpg'),
            require ('../../assets/img/productos/telasParaCortina/driftBO/4.jpg')
        ]
    },
    {
        nombre: 'Stones BO',
        colores: ['Basalto', 'Marble', 'Granito', 'Cuarzo', 'Arena', 'Ambar', 'Slate'],
        tipo: 'Blackout',
        anchoRollo: '2.80 M',
        composicion: '100% Poliéster',
        pesoTela: '360 g/m²',
        categoria: 'Telas para cortina',
        images: [
            require ('../../assets/img/productos/telasParaCortina/stonesBO/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/stonesBO/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/stonesBO/2.jpg'),
            require ('../../assets/img/productos/telasParaCortina/stonesBO/3.jpg'),
            require ('../../assets/img/productos/telasParaCortina/stonesBO/4.jpg'),
            require ('../../assets/img/productos/telasParaCortina/stonesBO/5.jpg'),
            require ('../../assets/img/productos/telasParaCortina/stonesBO/6.jpg'),
            require ('../../assets/img/productos/telasParaCortina/stonesBO/7.jpg')
        ]
    },






    {
        nombre: 'Cortina Plitz Francés',
        colores: ['Muestra', 'Muestra', 'Muestra'],
        tipo: 'Plitz Francés',
        descripcion: 'La cortina plitz francés está Inspirada en lo tradicional por su estilo clásico y en lo contemporáneo por poderse realizar con infinidad de tejidos modernos. Su diseño es uno de los favoritos y más solicitados en la confección de cortinas por ofrecer una buena ondulación y una elegante caída a las telas. Este estilo de plisado es ideal para tergales y en tejidos blackout con el cortinero correcto bloquea de manera más eficiente la entrada de luz en la parte superior. Este tipo de cortina utiliza un sistema de ganchos que hace más práctica y eficiente la colocación y posterior desmontaje.',
        categoria: 'Confección de cortinas',
        images: [
            require ('../../assets/img/productos/telasParaCortina/cortinaPlitzF/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/cortinaPlitzF/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/cortinaPlitzF/2.jpg'),
            require ('../../assets/img/productos/telasParaCortina/cortinaPlitzF/3.jpg'),
        ]
    },
    {
        nombre: 'Cortina ondulada (Ripplefold)',
        colores: ['Muestra', 'Muestra', 'Muestra'],
        tipo: 'Ondulada',
        descripcion: 'La cortina ondulada se distingue por su modernidad y un efecto visual particularmente atractivo. Las ondas realzan la caída de la tela dándole ese toque elegante a los espacios. Cada pliegue es idéntico en su ondulación y se aprecia en ambas vistas de la cortina. Este tipo de cortina puede confeccionarse con la gran mayoría de telas y para su correcto funcionamiento utiliza un cortinero con un sistema especializado de broches o ganchos.',
        categoria: 'Confección de cortinas',
        images: [
            require ('../../assets/img/productos/telasParaCortina/cortinaOndulada/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/cortinaOndulada/1.jpg'),
            require ('../../assets/img/productos/telasParaCortina/cortinaOndulada/2.jpg'),
            require ('../../assets/img/productos/telasParaCortina/cortinaOndulada/3.jpg'),
        ]
    }

].map(producto => ({
    ...producto,
    id: generateIdFromName(producto.nombre),
    slug: `${producto.nombre.toLowerCase().replace(/\s+/g, '-')}-${producto.categoria.toLowerCase().replace(/\s+/g, '-')}`,
    categoriaSlug: producto.categoria.toLowerCase().replace(/\s+/g, '-')
  }));
export default telasParaCortina;